import { GridQueryParams } from "./@types";

export const configuredAlertsKeys = {
  list: ["list"],
  listWithParams: (params?: GridQueryParams | undefined) => [
    ...configuredAlertsKeys.list,
    params
  ],
  detail: (id?: string) => ["detail", id]
};

export const deliveryMethodsKeys = {
  list: ["alertsActionsList"],
  listWithParams: (params?: GridQueryParams | undefined) => [
    ...deliveryMethodsKeys.list,
    params
  ]
};
